// main.js
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'

Vue.config.productionTip = false

// Remove the '/api' from the development baseURL
axios.defaults.baseURL = process.env.NODE_ENV === 'production' 
  ? '/api' 
  : 'http://192.168.195.64:8088'  // Removed '/api' from the end
  // : 'http://222.71.38.108'  // Removed '/api' from the end
  // : 'http://222.71.38.108:3838'  // Removed '/api' from the end

Vue.prototype.$http = axios

// 创建更清晰的粒子背景效果
const particleScript = document.createElement('script')
particleScript.innerHTML = `
  document.addEventListener('DOMContentLoaded', function() {
    const canvas = document.createElement('canvas');
    canvas.id = 'particle-canvas';
    canvas.style.position = 'fixed';
    canvas.style.top = '0';
    canvas.style.left = '0';
    canvas.style.width = '100%';
    canvas.style.height = '100%';
    canvas.style.zIndex = '-1';
    document.body.appendChild(canvas);
    
    const ctx = canvas.getContext('2d');
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    
    const particles = [];
    // 增加粒子数量使背景更丰富
    const particleCount = 100;
    // 使用更鲜艳的颜色
    const colors = ['#6366f1', '#818cf8', '#38bdf8', '#22d3ee', '#a5b4fc'];
    
    class Particle {
      constructor() {
        this.x = Math.random() * canvas.width;
        this.y = Math.random() * canvas.height;
        // 增大粒子尺寸使其更清晰可见
        this.size = Math.random() * 3 + 1.5;  // 尺寸范围：1.5-4.5
        this.speedX = Math.random() * 1 - 0.5;
        this.speedY = Math.random() * 1 - 0.5;
        this.color = colors[Math.floor(Math.random() * colors.length)];
        // 增加粒子透明度使其更明显
        this.alpha = Math.random() * 0.3 + 0.3;  // 透明度范围：0.3-0.9
      }
      
      update() {
        this.x += this.speedX;
        this.y += this.speedY;
        
        if (this.x > canvas.width || this.x < 0) this.speedX *= -1;
        if (this.y > canvas.height || this.y < 0) this.speedY *= -1;
      }
      
      draw() {
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
        ctx.fillStyle = this.color;
        ctx.globalAlpha = this.alpha;
        ctx.fill();
      }
    }
    
    function init() {
      for (let i = 0; i < particleCount; i++) {
        particles.push(new Particle());
      }
    }
    
    function animate() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      
      for (let i = 0; i < particles.length; i++) {
        particles[i].update();
        particles[i].draw();
        
        for (let j = i; j < particles.length; j++) {
          const dx = particles[i].x - particles[j].x;
          const dy = particles[i].y - particles[j].y;
          const distance = Math.sqrt(dx * dx + dy * dy);
          
          // 减小连线距离阈值并增加连线可见度
          if (distance < 120) {
            ctx.beginPath();
            ctx.strokeStyle = particles[i].color;
            // 增加连线透明度
            ctx.globalAlpha = 0.15 * (1 - distance/120);
            // 增加连线宽度
            ctx.lineWidth = 1;
            ctx.moveTo(particles[i].x, particles[i].y);
            ctx.lineTo(particles[j].x, particles[j].y);
            ctx.stroke();
          }
        }
      }
      
      requestAnimationFrame(animate);
    }
    
    init();
    animate();
    
    window.addEventListener('resize', function() {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    });
  });
`
document.head.appendChild(particleScript);

// 只保留一个Vue实例
new Vue({
  router, // 确保注入路由
  render: h => h(App),
}).$mount('#app')